import { FC } from "react";
import { components, MenuProps } from "react-select";

import { DashboardResetDefaultsButton } from "./dashboard-reset-defaults-button";

type IViewDropdownMenuProps = MenuProps;

export const ViewDropdownMenu: FC<IViewDropdownMenuProps> = props => {
  return (
    <components.Menu {...props}>
      {props.children}
      <DashboardResetDefaultsButton />
    </components.Menu>
  );
};
